import React, { useState, useContext, useEffect } from "react";
import { toast } from "react-toastify";
import { reducer } from "../../../../context";
import actionType from "../../../../context/actionType";
import { useTranslation } from "react-i18next";
import i18n_address from "../../../../i18n_addr";
import package_json from "../../../../../package.json";

const ICONS = [
  {
    title: "Instagram",
    imgUrl: "/donation/assets/icons/Instagram-w.svg",
  },
  {
    title: "Facebook",
    imgUrl: "/donation/assets/icons/Facebook-w.svg",
  },
  {
    title: "YouTube",
    imgUrl: "/donation/assets/icons/Youtube-w.svg",
  },
  {
    title: "E-Mail",
    imgUrl: "/donation/assets/icons/mail-w.svg",
  },
];
const LANGUAGES = ["en", "zhTW", "cn"];

interface FooterStyleType {
  [key: string]: {};
}

const FOOTER_STYLE: FooterStyleType = {
  login: {},
  assetList: {
    marginTop: 399,
  },
  donationForm: {
    marginTop: 75,
  },
  nameplate: {
    marginTop: 301,
  },
  payment: {
    marginTop: 124,
  },
  completion: {
    // marginTop: 193,
  },
};

const buttonStyle = (useChinese: boolean, selected: boolean) => ({
  fontFamily: useChinese ? "Microsoft JhengHei" : "Rambla",
  color: selected ? "#2c3c4e" : "white",
  marginRight: 8,
  backgroundColor: selected ? "white" : "#2c3c4e",
  cursor: "pointer",
});

const textStyle = (useChinese: boolean) => ({
  ...(useChinese
    ? {
        fontFamily: "Microsoft JhengHei",
      }
    : {
        fontFamily: "Rambla",
      }),
  fontSize: 20,
  color: "#ffffff",
  marginTop: 43,
  marginBottom: 15,
});

interface Props {
  style: any;
}

const Footer: React.FunctionComponent<Props> = (props) => {
  const { formReducer, configReducer } = useContext(reducer);
  const [debugModeCount, setDebugModeCount] = useState(0);
  const footerStyle = FOOTER_STYLE[formReducer.state.screen || ""];
  const { t, i18n } = useTranslation();
  const { t: t_addr, i18n: i18n_addr } = useTranslation("", {
    i18n: i18n_address,
  });
  const useChinese = i18n.language === "zhTW" || i18n.language === "cn";
  useEffect(() => {
    if (!i18n.language) {
      i18n.changeLanguage(LANGUAGES[1]);
    }
    if (!i18n_addr.language) {
      i18n_addr.changeLanguage(LANGUAGES[1]);
    }
  }, []);
  useEffect(() => {
    if (debugModeCount === 5) {
      toast[configReducer.state.debugMode ? "error" : "info"](
        `Debug mode ${
          configReducer.state.debugMode ? "de-activated" : "activated"
        }. Please press button sequence to toggle back.`
      );
      configReducer.dispatch({
        type: actionType.config.SET_DEBUG_MODE,
        payload: {
          debugMode: !configReducer.state.debugMode,
        },
      });
      setDebugModeCount(0);
    }
  }, [debugModeCount]);
  return (
    <div
      style={{
        width: "100%",
        height: 145,
        backgroundColor: "#2c3e50",
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
        ...(footerStyle || {}),
      }}
    >
      <div
        onClick={() => setDebugModeCount((prevCount: number) => prevCount + 1)}
        style={textStyle(useChinese)}
      >
        {/* {t('followUs')} */}{" "}
      </div>
      <div style={{ display: "flex", flexDirection: "row" }}>
        {/* {ICONS.map((icon) => {
                    return <img key={icon.title} src={icon.imgUrl} style={{ marginRight: 25.8, width: 24, height: 24}} />
                })} */}
        {LANGUAGES.map((lng, index) => (
          <button
            key={index}
            onClick={() => {
              i18n.changeLanguage(lng);
              i18n_addr.changeLanguage(lng);
            }}
            style={buttonStyle(useChinese, i18n.language == lng)}
          >
            {t(lng)}
          </button>
        ))}
        <div
          style={{ fontWeight: "bold", ...buttonStyle(useChinese, false) }}
          onClick={() => window.scrollTo(0, 0)}
        >
          {t("top")}
        </div>
        <div style={{ ...buttonStyle(useChinese, false), fontSize: "x-small" }}>
          Ver: {package_json.version_display}
        </div>
      </div>
      <div
        style={{
          ...(useChinese
            ? {
                fontFamily: "Microsoft JhengHei",
              }
            : {
                fontFamily: "Rambla",
              }),
          display: "flex",
          flexDirection: "row",
          color: "white",
          paddingTop: 10,
        }}
      >
        {t("copyrightText0")}
                <br/>
        {t("copyrightText")}
      </div>
    </div>
  );
};

export default Footer;
